import React from 'react';
import PropTypes from 'prop-types';
import colors from '@general/colors';

const CaretUpIcon = ({ color = colors.black }) => {
    return (
        <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M3.5 10L8 5.5L12.5 10"
                stroke={color}
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

CaretUpIcon.propTypes = {
    color: PropTypes.string,
};

export default CaretUpIcon;
